import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import i18n from '../i18n'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    redirect: `/${i18n.locale}`
  },
  {
    // Root-level route — matches email links: /reset-password?token=...
    path: '/reset-password',
    name: 'Reset-Password-Root',
    component: () => import('../views/Reset-Password.vue')
  },
  {
    path: '/:lang',
    component: {
      render (c) { return c('router-view') }
    },
    beforeEnter: (to, from, next) => {
      const supportedLocales = ['en', 'zh']
      if (!supportedLocales.includes(to.params.lang)) {
        return next('/en') // Redirect to home page with default locale
      }
      i18n.locale = to.params.lang
      return next()
    },
    children: [
      {
        path: '/',
        name: 'Home',
        component: Home
      },
      {
        path: 'services',
        name: 'Services',
        component: () => import('../views/Services.vue')
      },
      {
        path: 'management-team',
        name: 'Management-Team',
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () => import(/* webpackChunkName: "management-team" */ '../views/Management-Team.vue')
      },
      // {
      //   path: 'why-us',
      //   name: 'Why-Us',
      //   component: () => import('../views/Why-Us.vue')
      // },
      {
        path: 'deadline',
        name: 'Deadline',
        component: () => import('../views/Deadline.vue')
      },
      {
        path: 'contact-us',
        name: 'Contact-Us',
        component: () => import('../views/Contact-Us.vue')
      },
      {
        path: 'policy',
        name: 'policy',
        component: () => import('../views/Policy.vue')
      },
      {
        path: 'legal',
        name: 'legal',
        component: () => import('../views/Legal.vue')
      },
      {
        path: 'login',
        name: 'Login',
        component: () => import('../views/client/Login.vue')
      },
      {
        path: 'reset-password',
        name: 'Reset-Password',
        component: () => import('../views/Reset-Password.vue')
      },
      {
        path: 'document-signed',
        name: 'Document-Signed',
        component: () => import('../views/Document-Signed.vue')
      },
      {
        path: 'company-registration-form',
        name: 'Company-Registration-Form',
        component: () => import('../views/Company-Registration-Form.vue')
      },
      {
        path: 'admin-login',
        name: 'Admin-Login',
        component: () => import('../views/admin/Admin-Login.vue')
      },
      {
        path: 'staff-login',
        name: 'Staff-Login',
        component: () => import('../views/staff/Staff-Login.vue')
      },
      {
        path: 'admin-panel',
        name: 'Admin-Panel',
        component: () => import('../views/admin/Admin-Panel.vue'),
        meta: { requiresAdminAuth: true }
      },
      {
        path: 'admin-panel/new-client',
        name: 'Admin-New-Client',
        component: () => import('../views/admin/AdminNewClient.vue'),
        meta: { requiresAdminAuth: true }
      },
      {
        path: 'admin-panel/edit-client/:id',
        name: 'Admin-Edit-Client',
        component: () => import('../views/admin/AdminEditClient.vue'),
        meta: { requiresAdminAuth: true }
      },
      {
        path: 'admin-panel/tasks/tax',
        name: 'Admin-Task-Tax',
        component: () => import('../views/admin/AdminTaskTax.vue'),
        meta: { requiresAdminAuth: true }
      },
      {
        path: 'admin-panel/tasks/cosec',
        name: 'Admin-Task-Cosec',
        component: () => import('../views/admin/AdminTaskCosec.vue'),
        meta: { requiresAdminAuth: true }
      },
      {
        path: 'admin-panel/tasks/incorporation',
        name: 'Admin-Task-Incorporation',
        component: () => import('../views/admin/AdminTaskIncorporation.vue'),
        meta: { requiresAdminAuth: true }
      },
      {
        path: 'admin-panel/tasks/billing',
        name: 'Admin-Task-Billing',
        component: () => import('../views/admin/AdminTaskBilling.vue'),
        meta: { requiresAdminAuth: true, requiresSuperAdmin: true }
      },
      {
        path: 'admin-panel/email-blast',
        name: 'Admin-Email-Blast',
        component: () => import('../views/admin/AdminEmailBlast.vue'),
        meta: { requiresAdminAuth: true }
      },
      {
        path: 'admin-panel/email-blast/monthly-deadlines',
        name: 'Admin-Email-Blast-Monthly',
        component: () => import('../views/admin/AdminEmailBlastMonthly.vue'),
        meta: { requiresAdminAuth: true }
      },
      {
        path: 'admin-panel/email-blast/general',
        name: 'Admin-Email-Blast-General',
        component: () => import('../views/admin/AdminEmailBlastGeneral.vue'),
        meta: { requiresAdminAuth: true }
      },
      {
        path: 'admin-panel/user-management',
        name: 'Admin-User-Management',
        component: () => import('../views/admin/AdminUserManagement.vue'),
        meta: { requiresAdminAuth: true, requiresSuperAdmin: true }
      },
      {
        path: 'admin-panel/staff/:id',
        name: 'Admin-Staff-Panel',
        component: () => import('../views/staff/StaffPanel.vue'),
        meta: { requiresAdminAuth: true, requiresSuperAdmin: true }
      },
      {
        path: 'staff-panel',
        name: 'Staff-Panel',
        component: () => import('../views/staff/StaffPanel.vue'),
        meta: { requiresStaffAuth: true }
      },
      {
        path: 'user-panel',
        name: 'User-Panel',
        component: () => import('../views/client/User-Panel.vue'),
        meta: { requiresAuth: true }
      },
      {
        path: '*',
        redirect: to => {
          return { path: `/${i18n.locale}` }
        }
      }
    ]
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior (to, from, savedPosition) {
    return { x: 0, y: 0 } // Scroll to top on route change
  }
})

router.beforeEach((to, _from, next) => {
  const adminToken = localStorage.getItem('adminToken')
  const adminRole = localStorage.getItem('adminRole')
  const staffToken = localStorage.getItem('staffToken')

  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (!localStorage.getItem('client_access_token')) {
      return next({ name: 'Login', params: { lang: i18n.locale } })
    }
  }

  // Staff-only route guard — uses dedicated staff keys, never conflicts with admin session
  if (to.matched.some(record => record.meta.requiresStaffAuth)) {
    if (!staffToken) {
      return next({ name: 'Staff-Login', params: { lang: i18n.locale } })
    }
  }

  // Admin/super-admin routes — staff keys are separate so no cross-contamination possible
  if (to.matched.some(record => record.meta.requiresAdminAuth)) {
    if (!adminToken) {
      return next({ name: 'Admin-Login', params: { lang: i18n.locale } })
    }
  }

  if (to.matched.some(record => record.meta.requiresSuperAdmin)) {
    if (adminRole !== 'super_admin') {
      return next({ name: 'Admin-Panel', params: { lang: i18n.locale } })
    }
  }

  next()
})

// Add a global error handler
router.onError((error) => {
  console.error('Router error:', error)
  router.push('/en')
})

export default router
